'use client';

import { c as _c } from "react/compiler-runtime";
import { ChevronButton } from '@/components/ChevronButton';
import { useTestimonialsBlockState } from './TestimonialsBlockProvider';
export function TestimonialsBlockNavigation() {
  const $ = _c(7);
  const {
    cardState$
  } = useTestimonialsBlockState();
  let t0;
  if ($[0] !== cardState$.handlePrevClicked) {
    t0 = <ChevronButton variant="prev" onClick={cardState$.handlePrevClicked} className="pointer-events-auto shadow-[0_4px_10px_0_rgba(0,0,0,0.10)]" aria-label="Previous testimonial" />;
    $[0] = cardState$.handlePrevClicked;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== cardState$.handleNextClicked) {
    t1 = <ChevronButton variant="next" onClick={cardState$.handleNextClicked} className="pointer-events-auto shadow-[0_4px_10px_0_rgba(0,0,0,0.10)]" aria-label="Next testimonial" />;
    $[2] = cardState$.handleNextClicked;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t0 || $[5] !== t1) {
    t2 = <div className="absolute top-1/2 left-1/2 transform -translate-1/2 max-w-85 md:max-w-312 w-full flex justify-between z-99 pointer-events-none px-2 md:px-4">{t0}{t1}</div>;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}